import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import './index.css';
import App from './App';

// ─────────────────────────────────────────────────────────────────────────────
// TanStack Query client — adds page-level caching, dedup, and stale-while-
// revalidate. Without it, every navigation back to a page re-fetches
// everything from scratch and feels sluggish. With it, the page renders
// from cache instantly and silently refetches in the background.
// Tuning notes:
//   • staleTime 30s — data is "fresh" for 30s, so navigating back within
//     30s shows cached data with NO network call. After 30s, cached data
//     is shown immediately but a background refetch happens.
//   • gcTime 5min — unused queries are kept in cache for 5 min before GC.
//   • retry 1 — one auto-retry on network error (avoids flaky UX).
//   • refetchOnWindowFocus false — too aggressive for an admin dashboard.
// ─────────────────────────────────────────────────────────────────────────────
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime:    5 * 60 * 1000,
      retry:     1,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
